import { useParams } from "react-router-dom";
import { useState } from "react";
import { useEffect } from "react";
import AccountInfos from "../../components/accounts/accountinfos";
import ProfilsAccount from "../../components/profils/profilsaccount";



export default function ViewAccount() {
    // states
    let codeaccount = useParams();
    const [page, setPage] = useState(0);


    const displayPages = () => {
        if (page === 0) {
            return <AccountInfos codeaccount={codeaccount.code} />;
        } else {
            return <ProfilsAccount account={codeaccount.code} />;
        }
        // else {
        //     return <EmployeeScans refid={refId} code={codeemploye.code}  />;
        // }
    }


    // comportements
    useEffect(() => {

    }, []);



    // affichages
    return (
        <div className="container-fluid">
            <h1 className="h4 mb-2 font-weight-bold text_primary">Accounts</h1>
            <div style={{ display: "flex", flexDirection: "row", justifyContent: "start", justifyItems: "center" }}>
                <button onClick={() => { setPage(0) }} className={`btn-shadow rounded-0 btn ${page === 0 ? 'btn-primary' : 'btn-secondary'}`}>
                    <span>Account informations</span>
                </button>
                <button onClick={() => { setPage(1) }} className={`btn-shadow rounded-0 btn ${page === 1 ? 'btn-primary' : 'btn-secondary'}`}>
                    <span>Accounts profils</span>
                </button>
            </div>
            {displayPages()}
        </div>
    )
}